import { GuestUnitDetailsScreen } from '@/modules/guest-web';
import { GuestRouteGate } from '@/modules/guest-web/components/GuestRouteGate';

/** Public guest unit details — `/guest-details?id=` (flat file route for static export). */
export default function GuestDetailsRoute() {
  return (
    <GuestRouteGate>
      <GuestUnitDetailsScreen />
    </GuestRouteGate>
  );
}
